import { useEffect, useState } from "react";
import { api, fileUrl } from "../lib/api";
import { Link } from "react-router-dom";
import { Tag } from "lucide-react";

const HORSE_PLACEHOLDER = "https://images.pexels.com/photos/32076745/pexels-photo-32076745.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const Ticker = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/horses/for-sale").then(r => setItems(r.data || [])).catch(() => {});
  }, []);

  if (items.length === 0) {
    return (
      <div className="bg-[#1B3B5A] text-[#FBF9F6] py-3">
        <div className="max-w-7xl mx-auto px-4 flex items-center gap-3 text-sm">
          <Tag size={14} className="text-[#B8860B]" />
          <span className="uppercase tracking-[0.2em] text-xs text-[#B8860B] font-bold">Зар</span>
          <span className="text-[#FBF9F6]/80">Одоогоор зарагдах адуугүй байна.</span>
        </div>
      </div>
    );
  }

  // Duplicate items for seamless marquee
  const loop = [...items, ...items];

  return (
    <div className="bg-[#1B3B5A] text-[#FBF9F6] py-3 border-y border-[#B8860B]/40 overflow-hidden" data-testid="sale-ticker">
      <div className="flex items-center gap-3">
        <div className="shrink-0 flex items-center gap-2 px-4 border-r border-[#B8860B]/40">
          <Tag size={14} className="text-[#B8860B]" />
          <span className="uppercase tracking-[0.2em] text-xs text-[#B8860B] font-bold">Зарагдах адуу</span>
        </div>
        <div className="overflow-hidden flex-1">
          <div className="ticker">
            {loop.map((h, idx) => (
              <Link
                key={`${h.id}-${idx}`}
                to={`/horse/${h.id}`}
                className="flex items-center gap-3 shrink-0 pr-10 hover:text-[#B8860B] transition-colors"
                data-testid={`ticker-${h.id}`}
              >
                <img src={h.photo_path ? fileUrl(h.photo_path) : HORSE_PLACEHOLDER} alt={h.name} className="h-7 w-7 object-cover rounded-full border border-[#B8860B]/40" />
                <span className="text-sm font-semibold">{h.name}</span>
                {h.registration_number && <span className="text-xs text-[#FBF9F6]/70">№{h.registration_number}</span>}
                {h.sale_price && <span className="text-xs text-[#B8860B] font-bold">{h.sale_price}</span>}
                {h.sale_contact && <span className="text-xs text-[#FBF9F6]/70">☏ {h.sale_contact}</span>}
                <span className="text-[#B8860B]">•</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ticker;
